import * as defaultImport from "@splunk/react-ui/Typography";
export * from "@splunk/react-ui/Typography";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
